import { Alerts } from "../../../utils/Alerts.js";
import { useRPCContext } from "../../../contexts/RPCContext.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
import { useUser } from "../hooks/useUser.js";
import { ErrorLoadingRetry } from "../../../components/ErrorLoadingRetry.js";
import { SelectAllowedUserPositionOption } from "./SelectAllowedUserPositionOption.js";
import { useCallback, useState } from "react";
import { Button, Icon, Loading } from "@therms/atalaya";
import { IoClose } from "react-icons/io5";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { RPCs } from "@therms/rpc-gateway";
import { getColorContrast } from "@therms/web-js";
import { MdGpsFixed } from "react-icons/md";
//#region src/modules/Users/shared/SetDutyStatus.tsx
function SetDutyStatus({ onComplete, userId }) {
	const { rpcService } = useRPCContext();
	const { data: userData } = useUser({ userId });
	const user = userData?.user;
	const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
	const [currentPosition, setCurrentPosition] = useState(user?.position ?? void 0);
	const { call: getUserStatusOptions, data, isCalling, success } = useRPC(RPCs.Users.GetAllowedUserStatusOptionsAndPositions.v1, { targetUserId: userId });
	const handleUserPositionOptionChange = (userPositionOption) => {
		setCurrentPosition(userPositionOption);
		rpcService.Users.SetUserPosition.v1.call({
			userId,
			userPositionOptionId: userPositionOption?.id
		});
	};
	const setUserStatus = useCallback(async (status) => {
		setIsUpdatingStatus(true);
		try {
			await rpcService.Users.SetUserStatus.v1.call({
				userId,
				userStatusOptionId: status?.id ?? null
			});
			if (status?.id) Alerts.success(`Duty Status has been set`);
			else Alerts.success(`Duty Status has been cleared`);
		} catch (err) {
			Alerts.error("There was a problem setting the Duty Status", err.message);
			console.log("setUserStatus() err", err);
		} finally {
			setIsUpdatingStatus(false);
			onComplete();
		}
	}, [userId]);
	if (isCalling && !data || isUpdatingStatus || !user) return /* @__PURE__ */ jsx(Loading, {
		className: "min-h-base",
		overlay: true
	});
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [(isCalling && !data || isUpdatingStatus || !user) && /* @__PURE__ */ jsx(Loading, {
		className: "min-h-base",
		overlay: true
	}), !isCalling && !success ? /* @__PURE__ */ jsx(ErrorLoadingRetry, { onRetry: getUserStatusOptions }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [
		!user.status?.shiftId && /* @__PURE__ */ jsx("div", {
			className: "mb-sm",
			children: /* @__PURE__ */ jsx(SelectAllowedUserPositionOption, {
				targetUserId: userId,
				isClearable: true,
				isSearchable: false,
				label: "Duty Status Position",
				onChangeOptions: handleUserPositionOptionChange,
				placeholder: "Position",
				subText: !currentPosition && `No Position set`,
				value: currentPosition?.id
			})
		}),
		data?.userStatusOptions?.map((userStatusOption) => /* @__PURE__ */ jsx("div", {
			className: "mb-xxs transition-[filter] hover:brightness-110 focus:brightness-110 active:brightness-90",
			children: /* @__PURE__ */ jsx(Button, {
				fullWidth: true,
				onClick: () => setUserStatus(userStatusOption),
				style: {
					backgroundColor: userStatusOption.color,
					color: getColorContrast(userStatusOption.color)
				},
				children: /* @__PURE__ */ jsxs("div", {
					className: "px-sm py-xxs inline-flex w-full items-center justify-between",
					children: [userStatusOption.title, userStatusOption.geoTracking && /* @__PURE__ */ jsxs("div", {
						className: "ml-xs bg-surface-subtle px-xs text-color-subtle rounded text-sm opacity-60",
						children: [/* @__PURE__ */ jsx(Icon, {
							Icon: MdGpsFixed,
							size: "sm"
						}), " Location Tracking"]
					})]
				})
			})
		}, userStatusOption.title + userStatusOption.color)),
		user?.status && !user.status.shiftId && /* @__PURE__ */ jsx(Button, {
			className: "mt-base",
			fullWidth: true,
			onClick: () => setUserStatus(void 0),
			outline: true,
			variant: "neutral",
			children: /* @__PURE__ */ jsxs("span", {
				className: "p-sm",
				children: [/* @__PURE__ */ jsx(Icon, { Icon: IoClose }), " Clear Status / Off-Duty"]
			})
		})
	] })] });
}
//#endregion
export { SetDutyStatus };

//# sourceMappingURL=SetDutyStatus.js.map